import React, { createContext, useCallback, useMemo, useState } from "react";
import NavigationAlertModal from "../../modals/NavigationAlertModal";

// Create a context to manage the confirmation dialog
export const ConfirmCtx = createContext(null);

export function ConfirmProvider({ children }) {
  const [confirm, setConfirm] = useState(null); // Store the current confirmation options
  const [open, toggle] = useState(false); // Track whether the confirmation dialog is open

  // Function to show the confirmation dialog
  const show = useCallback(
    (confirmOptions) => {
      setConfirm(confirmOptions);
      toggle(true); // Open the dialog
    },
    [toggle]
  );

  // Handle the confirmation action
  const onConfirm = () => {
    if (confirm?.onConfirm) confirm.onConfirm(); // Call the onConfirm callback if provided
    toggle(false); // Close the dialog
  };

  // Handle the cancel action
  const onCancel = () => {
    if (confirm?.onCancel) confirm.onCancel(); // Call the onCancel callback if provided
    toggle(false); // Close the dialog
  };

  // Context value to provide the `show` function for displaying confirmation
  const value = useMemo(() => ({ show }), [show]);

  return (
    <ConfirmCtx.Provider value={value}>
      <NavigationAlertModal
        onCancel={onCancel}
        onConfirm={onConfirm}
        open={open}
      />
      {children}
    </ConfirmCtx.Provider>
  );
}
